import {Component} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  templateUrl: "./levels.premium-shop-page.component.html"
})


export class LevelsPremiumShopPageComponent {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Магазин премиум валюты - Уровни");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.PREM_SHOP_LEVELS)
    .setListLabels("максимум опыта", "%/maxXp%")
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));

  VALUE_TYPE = VALUE_TYPE;
  document: IDocument;


  constructor(private busService: BusService) {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = e.document);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/prem_shop/levels.premium-shop.page.component.ts